import { defineMessages } from 'react-intl'

export default defineMessages({
  pleaseSelectAudience: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.PleaseSelectAudience',
    defaultMessage: 'Select Audience Type'
  },
  selectAudience: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AudienceTarget',
    defaultMessage: 'Select Audience'
  },
  addAddressesLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Addresses.Label',
    defaultMessage: 'Add Address'
  },
  addAddressesPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Addresses.Placeholder',
    defaultMessage: 'Address Name'
  },
  addAggregateAttributeLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AggregateAttribute.Label',
    defaultMessage: 'Add {displayName}'
  },
  addDepartmentPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Department.Placeholder',
    defaultMessage: 'Department name'
  },
  addEmailsLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Emails.Label',
    defaultMessage: 'Add Email'
  },
  addGroupsLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Groups.Label',
    defaultMessage: 'Add Group'
  },
  addGroupsPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AddGroupsPlaceholder',
    defaultMessage: 'Group name'
  },
  addManagerLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Manager.Label',
    defaultMessage: 'Add Manager'
  },
  addNameLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Name.Label',
    defaultMessage: 'Add Individual'
  },
  addNamePlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.Name.Placeholder',
    defaultMessage: 'Employee name or email'
  },
  addPhoneNumbersLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.PhoneNumbers.Label',
    defaultMessage: 'Add Phone Number'
  },
  addAdditionalAudience: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AdditionalAudience',
    defaultMessage: 'Audience'
  },
  pleaseSelectOperator: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.PleaseSelectOperator',
    defaultMessage: 'Select Option'
  },
  addFilter: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AddFilter',
    defaultMessage: 'Filter'
  },
  ruleHeader: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.AudienceTarget.Header',
    defaultMessage: 'Audience Target: Rule'
  },
  defineRule1Filter: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.RuleDefinition',
    defaultMessage: '{name} {expressionOperator} {audienceType} {audienceValue}'
  },
  defineRule2Filter: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.RuleDefinition2',
    defaultMessage:
      '{name} {expressionOperator1} {audienceType1} {audienceValue1} {logicalOperator} {expressionOperator2} {audienceType2} {audienceValue2}'
  },
  defineRule3FilterSameLogicSameExp: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.RuleDefinition3SameLogicSameExp',
    defaultMessage:
      '{name} {expressionOperator} {audienceType1} {audienceValue1}, {audienceType2} {audienceValue2},  {logicalOperator} {audienceType3} {audienceValue3}'
  },
  defineRule3FilterSameLogicDiffExp: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.RuleDefinition3SameLogicDiffExp',
    defaultMessage: '{name} {audienceA} {logicalOperator} who are not {audienceB}'
  },
  defineRule3FilterDiffLogic: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.RuleDefinition3DiffLogic',
    defaultMessage: '{name} {audienceA} OR those {audienceB}'
  },
  theApp: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.DefaultName',
    defaultMessage: 'This {name} will be turned on for all users'
  },
  confirmDelete: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting.DeleteRule',
    defaultMessage: 'Are you sure you want to delete this audience targeting rule?'
  }
})
